import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "col-md-6 mx-auto" }
const _hoisted_2 = { class: "dl-horizontal" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("dt", null, "ID", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("dt", null, "Name", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("dt", null, "Email", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("dt", null, "Facebook ID", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("dt", null, "Create Time", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("dt", null, "Ruby", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("dt", null, "Total Credit", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("dt", null, "Bought Credit", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("dt", null, "Is ban", -1)
const _hoisted_14 = {
  key: 0,
  class: "badge badge-warning"
}
const _hoisted_15 = {
  key: 1,
  class: "badge badge-info"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("dt", null, "Is ban chat", -1)
const _hoisted_17 = {
  key: 0,
  class: "badge badge-warning"
}
const _hoisted_18 = {
  key: 1,
  class: "badge badge-info"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("dt", null, "Is mute", -1)
const _hoisted_20 = {
  key: 0,
  class: "badge badge-warning"
}
const _hoisted_21 = {
  key: 1,
  class: "badge badge-info"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("dt", null, "Is deleting", -1)
const _hoisted_23 = {
  key: 0,
  class: "badge badge-danger"
}
const _hoisted_24 = {
  key: 1,
  class: "badge badge-info"
}
const _hoisted_25 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("dt", null, "Online time", -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("dt", null, "Last login (time)", -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("dt", null, "Last login (ip)", -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("dt", null, "Last login (version)", -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("dt", null, "Last login (deviceOS)", -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("dt", null, "Average payment", -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("dt", null, [
  /*#__PURE__*/_createTextVNode(" RFM recency "),
  /*#__PURE__*/_createElementVNode("i", {
    class: "fas fa-question-circle",
    title: "How long does this account take from last payment? (day)",
    "data-toggle": "tooltip"
  })
], -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("dt", null, [
  /*#__PURE__*/_createTextVNode(" RFM frequency "),
  /*#__PURE__*/_createElementVNode("i", {
    class: "fas fa-question-circle",
    title: "How many times has this account purchased?",
    "data-toggle": "tooltip"
  })
], -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("dt", null, [
  /*#__PURE__*/_createTextVNode(" RFM monetary "),
  /*#__PURE__*/_createElementVNode("i", {
    class: "fas fa-question-circle",
    title: "How much did this account spend?",
    "data-toggle": "tooltip"
  })
], -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("dt", null, [
  /*#__PURE__*/_createTextVNode(" RFM persona "),
  /*#__PURE__*/_createElementVNode("i", {
    class: "fas fa-question-circle",
    title: "What kind of persona does this account belong to?",
    "data-toggle": "tooltip"
  })
], -1)
const _hoisted_37 = { class: "card-footer bg-white border border-light" }
const _hoisted_38 = { class: "col text-center" }
const _hoisted_39 = { class: "pt-1" }
const _hoisted_40 = { class: "pt-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_button = _resolveComponent("app-button")!
  const _component_app_card = _resolveComponent("app-card")!

  return (_openBlock(), _createBlock(_component_app_card, {
    class: "col-lg-8 mx-auto",
    label: "Account Profile"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("dl", _hoisted_2, [
          _createElementVNode("tr", null, [
            _hoisted_3,
            _createElementVNode("dd", null, _toDisplayString(_ctx.model.account?.accountId), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_4,
            _createElementVNode("dd", null, _toDisplayString(_ctx.model.account?.name), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_5,
            _createElementVNode("dd", null, _toDisplayString(_ctx.model.account?.email), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_6,
            _createElementVNode("dd", null, _toDisplayString(_ctx.model.account?.facebookId), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_7,
            _createElementVNode("dd", null, _toDisplayString(_ctx.formatDate(_ctx.model.account?.createTime)), 1)
          ]),
          _hoisted_8,
          _createElementVNode("tr", null, [
            _hoisted_9,
            _createElementVNode("dd", null, _toDisplayString(_ctx.model.account?.ruby), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_10,
            _createElementVNode("dd", null, _toDisplayString(_ctx.model.account?.totalCredit), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_11,
            _createElementVNode("dd", null, _toDisplayString(_ctx.model.account?.boughtCredit), 1)
          ]),
          _hoisted_12,
          _createElementVNode("tr", null, [
            _hoisted_13,
            _createElementVNode("dd", null, [
              (_ctx.model.account?.isBanned)
                ? (_openBlock(), _createElementBlock("span", _hoisted_14, "Yes"))
                : (_openBlock(), _createElementBlock("span", _hoisted_15, "No"))
            ])
          ]),
          _createElementVNode("tr", null, [
            _hoisted_16,
            _createElementVNode("dd", null, [
              (_ctx.model.account?.isBanChat)
                ? (_openBlock(), _createElementBlock("span", _hoisted_17, "Yes"))
                : (_openBlock(), _createElementBlock("span", _hoisted_18, "No"))
            ])
          ]),
          _createElementVNode("tr", null, [
            _hoisted_19,
            _createElementVNode("dd", null, [
              (_ctx.model.account?.isMute)
                ? (_openBlock(), _createElementBlock("span", _hoisted_20, "Yes"))
                : (_openBlock(), _createElementBlock("span", _hoisted_21, "No"))
            ])
          ]),
          _createElementVNode("tr", null, [
            _hoisted_22,
            _createElementVNode("dd", null, [
              (_ctx.model.account?.isDeleting)
                ? (_openBlock(), _createElementBlock("span", _hoisted_23, "Yes"))
                : (_openBlock(), _createElementBlock("span", _hoisted_24, "No"))
            ])
          ]),
          _hoisted_25,
          _createElementVNode("tr", null, [
            _hoisted_26,
            _createElementVNode("dd", null, _toDisplayString(_ctx.toDuration(_ctx.model?.onlineTime)), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_27,
            _createElementVNode("dd", null, _toDisplayString(_ctx.formatDate(_ctx.model.lastLogin?.createTime)), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_28,
            _createElementVNode("dd", null, _toDisplayString(_ctx.model.lastLogin?.ipAddress), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_29,
            _createElementVNode("dd", null, _toDisplayString(_ctx.model.lastLogin?.version), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_30,
            _createElementVNode("dd", null, _toDisplayString(_ctx.model.lastLogin?.deviceOS), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_31,
            _createElementVNode("dd", null, _toDisplayString(_ctx.model.avgPayment?.avgPayment) + " in " + _toDisplayString(_ctx.model.avgPayment?.days) + " days", 1)
          ]),
          _hoisted_32,
          _createElementVNode("tr", null, [
            _hoisted_33,
            _createElementVNode("dd", null, _toDisplayString(_ctx.model.rfmSegmentation?.recencyFromDay), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_34,
            _createElementVNode("dd", null, _toDisplayString(_ctx.model.rfmSegmentation?.frequencyFromTransaction), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_35,
            _createElementVNode("dd", null, _toDisplayString(_ctx.model.rfmSegmentation?.monetaryFromPayment), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_36,
            _createElementVNode("dd", null, _toDisplayString(_ctx.model.rfmSegmentation?.personaNameList), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_37, [
        _createElementVNode("div", _hoisted_38, [
          _createElementVNode("div", null, [
            _createVNode(_component_app_button, {
              name: "Add chip",
              icon: "fa-plus",
              theme: "info",
              to: { name: _ctx.ROUTE_NAME_MESSAGE.SEND, query: { accountIds: _ctx.model.accountId } }
            }, null, 8, ["to"]),
            _createVNode(_component_app_button, {
              name: "Credit transaction",
              icon: "fa-hand-holding-heart",
              theme: "info",
              to: _ctx.routerLink.transaction(_ctx.TransactionType.Credit, _ctx.model.accountId)
            }, null, 8, ["to"])
          ]),
          _createElementVNode("div", _hoisted_39, [
            _createVNode(_component_app_button, {
              name: "Payment transaction",
              icon: "fa-hand-holding-usd",
              theme: "success",
              to: _ctx.routerLink.transaction(_ctx.TransactionType.Payment, _ctx.model.accountId)
            }, null, 8, ["to"]),
            _createVNode(_component_app_button, {
              name: "Ruby transtaction",
              icon: "fa-hand-holding",
              theme: "info",
              to: _ctx.routerLink.transaction(_ctx.TransactionType.Ruby, _ctx.model.accountId)
            }, null, 8, ["to"]),
            _createVNode(_component_app_button, {
              name: "Login history",
              icon: "fa-history",
              theme: "info",
              to: _ctx.routerLink.activity(_ctx.ActivityFilterType.AccountId.value, _ctx.model.accountId)
            }, null, 8, ["to"])
          ]),
          _createElementVNode("div", _hoisted_40, [
            (_ctx.model.account.isBanned)
              ? (_openBlock(), _createBlock(_component_app_button, {
                  key: 0,
                  name: "Unban",
                  icon: "fa-user-check",
                  theme: "success",
                  onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.actions.unban(_ctx.model.accountId)), ["prevent"]))
                }))
              : (_openBlock(), _createBlock(_component_app_button, {
                  key: 1,
                  name: "Ban",
                  icon: "fa-user-lock",
                  theme: "warning",
                  onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.actions.ban(_ctx.model.accountId)), ["prevent"]))
                })),
            (_ctx.model.account.isBanChat)
              ? (_openBlock(), _createBlock(_component_app_button, {
                  key: 2,
                  name: "Unban chat",
                  icon: "fa-comment",
                  theme: "success",
                  onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.actions.unbanChat(_ctx.model.accountId)), ["prevent"]))
                }))
              : (_openBlock(), _createBlock(_component_app_button, {
                  key: 3,
                  name: "Ban chat",
                  icon: "fa-comment-slash",
                  theme: "warning",
                  onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.actions.banChat(_ctx.model.accountId)), ["prevent"]))
                })),
            (_ctx.model.account.isMute)
              ? (_openBlock(), _createBlock(_component_app_button, {
                  key: 4,
                  name: "Unmut",
                  icon: "fa-microphone",
                  theme: "success",
                  onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.actions.unmute(_ctx.model.accountId)), ["prevent"]))
                }))
              : (_openBlock(), _createBlock(_component_app_button, {
                  key: 5,
                  name: "Mute",
                  icon: "fa-microphone-slash",
                  theme: "warning",
                  onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.actions.mute(_ctx.model.accountId)), ["prevent"]))
                })),
            (_ctx.model.account.isDeleting)
              ? (_openBlock(), _createBlock(_component_app_button, {
                  key: 6,
                  name: "Undelete",
                  icon: "fa-user-md",
                  theme: "success",
                  onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_ctx.actions.undelete(_ctx.model.accountId)), ["prevent"]))
                }))
              : (_openBlock(), _createBlock(_component_app_button, {
                  key: 7,
                  name: "Delete",
                  icon: "fa-user-lock",
                  theme: "danger",
                  onClick: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (_ctx.actions.delete(_ctx.model.accountId)), ["prevent"]))
                }))
          ])
        ])
      ])
    ]),
    _: 1
  }))
}